import { memo, useEffect } from 'react';
// Import Services
import { subscribe, unsubscribe } from 'services/event';
// Import Hooks
import { useMenuItem } from 'hooks/UseMenuItem';
// Import UI components
import { Dropdown, SkeletonLoader } from '@geneui/components';
// Import Constants
import { GlobalEvents, SubscriberSources } from 'constants/common';

interface Props {
    menuItemId: string;
    eventName?: keyof typeof GlobalEvents;
}

const MenuItemDropdownWithId: React.FC<Props> = ({ menuItemId, eventName, ...rest }) => {
    const { convertedData: dropdownData, isLoading: isLoadingDropdownData, restore } = useMenuItem(menuItemId);

    useEffect(() => {
        if (eventName) {
            subscribe(eventName, SubscriberSources.MenuItem, restore);
        }

        return () => {
            if (eventName) {
                unsubscribe(eventName, SubscriberSources.MenuItem);
            }
        };
    }, [restore, eventName]);

    return (
        <SkeletonLoader isBusy={isLoadingDropdownData}>
            {!isLoadingDropdownData && <Dropdown data={dropdownData} {...rest} />}
        </SkeletonLoader>
    );
};

export default memo(MenuItemDropdownWithId);
